/**
* Animate anchor link click 
*/
document.addEventListener('click', function (event) {
    if (event.target.matches('a[href^="#"]:not(.no-scroll-link, .scroll-link-ryzon, .disclosure__link, .nav__list__item__link, .language-form__element, .currency-selector__list__option)')) {
        var target = event.target.getAttribute('href');
        if (target !== '#close') {
            event.preventDefault();
            window.scrollTo({
                top: document.querySelector(target).offsetTop,
                behavior: 'smooth'
            });
        }
    }
});

initAccordion();

document.addEventListener('DOMContentLoaded', function () {
    dynamicHoverImageLoader()
    modifyDiscountCookie();
    initLazyload();
    checkLoginEvent();
    addChatbotListener();
    checkApplePayLogo();
    initTypingAnimation();
    initRemainingShippingProgressBar();
    // initUserFocusCookie(); // FIRST A/B TESTING!
    // Fallback, if something blocks the dumbo test. DUMBO_TEST_REMOVE
    setTimeout(function () {
        var loadingScreen = document.querySelector('.loading-screen');
        if (loadingScreen) loadingScreen.classList.remove('active');
    }, 3000);

    if (document.body.dataset.blackweek == '') {
        //initBlackweek();
    }

    if (document.querySelector('[data-countdown]')) {
        setInterval(startCountdowns, 1000);
    }
    checkShippingTimeElements();
});

function initUserFocusCookie() {
    const ryzon_user_focus = getCookie('ryzon_user_focus');
    if (ryzon_user_focus && ryzon_user_focus !== 'unisex') {
        document.querySelectorAll('a[href*="/collections/"]:not([href*="filter.v.m.filter.gender"])').forEach(link => {
            if (ryzon_user_focus === 'women' && (link.closest('.mega-menu__content[data-handle="maenner"]') || link.closest('#link-maenner'))) {
                return
            }
            if (ryzon_user_focus === 'men' && (link.closest('.mega-menu__content[data-handle="frauen"]') || link.closest('#link-frauen'))) {
                return;
            }
            let href = link.getAttribute('href');
            let separator = href.includes('?') ? '&' : '?';
            link.setAttribute('href', href + separator + 'filter.v.m.filter.gender=' + encodeURIComponent(ryzon_user_focus));
        });
    }
    if (getCookie('ryzon_session_page_depth') == 1 && meta?.page?.pageType == 'collection') {
        const selector = `input[type="checkbox"][name="filter.v.m.filter.gender"][value="${ryzon_user_focus}"]`;
        const inputs = Array.from(document.querySelectorAll(selector));
        inputs.forEach(input => {
            input.click();
        });
    }
}

function initRemainingShippingProgressBar() {
    const shippingProgressBar = document.querySelector('.remaining-shipping__content__progress__bar');
    if (shippingProgressBar) {
        setTimeout(function() {
          shippingProgressBar.style.setProperty('width', 'var(--progressbar-width)');
        }, 600);
    }
}

function checkApplePayLogo() {
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    var applePayElement = document.querySelector('.list-payment__item[data-type="apple_pay"]');
    if (!isSafari && applePayElement) {
        applePayElement.style.display = 'none';
    }
}

window.addEventListener('resize', function() {
    dynamicHoverImageLoader()
});

function addChatbotListener() {
    if (document.getElementById('open-chatbot-button')) {
      document.getElementById('open-chatbot-button').addEventListener('click', function() {
        const help_widget = document.querySelector('.help-widget__content');
        const open_widget_button = document.querySelector('.help-widget__open');
        const vg_chat_toggle = document.getElementById('vg_chat_toggle');
        if (help_widget && help_widget.offsetParent === null && open_widget_button) {
            open_widget_button.click();
        }
        if (vg_chat_toggle && !document.querySelector('.vg-chat-overlay-container')) {
          vg_chat_toggle.click();
        }
      });
    }
  }

function checkShippingTimeElements() {
    document.querySelectorAll('[class^="shipping-time-"]').forEach(function(shippingTimeElement) {
        if (shippingTimeElement.classList.contains('shipping-time-european-union')) {
            shippingTimeElement.innerHTML = shippingTimeEUR;
        } else if (shippingTimeElement.classList.contains('shipping-time-international')) {
            shippingTimeElement.innerHTML = shippingTimeINT;
        } else if (shippingTimeElement.classList.contains('shipping-time-austria')) {
            shippingTimeElement.innerHTML = shippingTimeAUT;
        } else if (shippingTimeElement.classList.contains('shipping-time-germany')) {
            shippingTimeElement.innerHTML = shippingTimeGER;
        } else if (shippingTimeElement.classList.contains('shipping-time-switzerland')) {
            shippingTimeElement.innerHTML = shippingTimeCHE;
        } else if (shippingTimeElement.classList.contains('shipping-time-usa')) {
            shippingTimeElement.innerHTML = shippingTimeUSA;
        }
    });
}

/**
 * Countdowns
 * 
 * data-countdown: manual
 * data-destroy: destroy element with this id after countdown is over
 * data-datetime: datetime in format 2023-11-19T09:00:00+01:00
 * data-reload: reload page after countdown is over
 * data-show-only: if set to "hh", only shows hours, minutes and seconds when days are 0
 * 
 * <span data-countdown="manual" data-destroy="banner__countdown--{{ section.id }}" data-datetime="{{ block.settings.countdown }}" data-show-only="hh">00d 00h 00m 00s</span>
 * 
 */
function startCountdowns() {
    const countdownElements = document.querySelectorAll('[data-countdown]');

    countdownElements.forEach((element) => {
        const countdownType = element.getAttribute('data-countdown');
        const showOnly = element.getAttribute('data-show-only');

        var useEnd = false;
        if (element.getAttribute('data-end') && element.getAttribute('data-end') == 'true') {
            useEnd = true;
        }

        if (countdownType == 'manual') {
            let datetime = new Date(element.getAttribute('data-datetime'));
            if (datetime instanceof Date && !isNaN(datetime.valueOf())) {
                updateCountdown(element, datetime, showOnly);
            } else {
                console.error('Invalid Date for countdown element', element);
            }
        } else {
            const event = shopClosedDateTimes.find((e) => e.name === countdownType);
            if (event) {
                if (useEnd) {
                    updateCountdown(element, event.end, showOnly);
                } else {
                    updateCountdown(element, event.start, showOnly);
                }
            }
        }
    });
}

function updateCountdown(element, targetTime, showOnly) {
    let currentDateTime = new Date();
    currentDateTime.setSeconds(currentDateTime.getSeconds());
    let timeDifference = targetTime - currentDateTime;
    
    if (timeDifference > 0) {
        let totalSeconds = Math.floor(timeDifference / 1000);
        let totalMinutes = Math.floor(totalSeconds / 60);
        let totalHours = Math.floor(totalMinutes / 60);
        let totalDays = Math.floor(totalHours / 24);

        let seconds = totalSeconds % 60;
        let minutes = totalMinutes % 60;
        let hours = totalHours % 24;
        let days = totalDays;

        if (showOnly === 'dd') {
            element.textContent = `${days}d`;
            return;
        } else if (showOnly === 'hh') {
            element.textContent = `${totalHours}h`;
            return;
        } else if (showOnly === 'mm') {
            element.textContent = `${totalMinutes}m`;
            return;
        } else if (showOnly === 'ss') {
            element.textContent = `${totalSeconds}s`;
            return;
        }

        days = days.toString().padStart(2, '0');
        hours = hours.toString().padStart(2, '0');
        minutes = minutes.toString().padStart(2, '0');
        seconds = seconds.toString().padStart(2, '0');
        if (days == '00') {
            element.textContent = `${hours}h ${minutes}m ${seconds}s`;
        } else {
            element.textContent = `${days}d ${hours}h ${minutes}m ${seconds}s`;
        }
    } else {
        element.textContent = "00d 00h 00m 00s";
        if (element.dataset.reload && element.dataset.reload == 'true') {
            location.reload();
        } else if (element.dataset.destroy && document.getElementById(element.dataset.destroy)) {
            document.getElementById(element.dataset.destroy).remove();
        }
    }
}

function initLazyload() {
    $('.lazyloadRzn').lazy({
        afterLoad: function (element) {
            element.attr('data-loaded', 'true');
        },
    });
}

/**
 * Accordion
 */
function initAccordion() {
    document.querySelectorAll('.panel-collapse:not(.in)').forEach(function(el) {
        el.style.display = 'none';
    });
    document.addEventListener('click', function(e) {
        var heading = e.target.closest('.panel-heading');
        if (!heading) return;
        heading.classList.toggle('minus');
        var next = heading.nextElementSibling;
        if (next && next.classList.contains('panel-collapse')) {
            next.style.display = next.style.display === 'none' ? '' : 'none';
        }
    });
}

/**
 * Modal close on click outside
 */
var moods = document.querySelectorAll(".modal");
for (var x = 0; x < moods.length; x++) {
    moods[x].addEventListener('click', function (event) {
        if (event.target == this) {
            this.classList.remove("modal--is-active");
            document.body.classList.remove("modal-open");
            if (this.id == "modHolder") {
                history.pushState("", document.title, window.location.pathname + window.location.search);
                this.querySelector(".modal__inner").classList.remove("vidHold");
                document.querySelector("body").classList.remove("cmActive");
                this.querySelector(".modal__inner").classList.remove("vidHoldcf");
                this.querySelector(".modal__inner").classList.remove("dark");
                this.querySelector(".modal__content").innerHTML = "";
                document.querySelector("#sharer").classList.remove("active");
                document.querySelector("#sharer").classList.remove("uih");
                cached && (cached = null);
            }

        }
    }, false);
}


/**
 * Tooltip
 */
const tooltipBox = document.createElement('div');
tooltipBox.id = 'tooltipBox';
tooltipBox.classList.remove('show');
tooltipBox.classList.add('wg-dynamic');
document.body.appendChild(tooltipBox);

if (!isTouchDevice()) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-tooltip]'), function (el) {
        var tooltipText = el.dataset.tooltip;
        el.onmouseover = function () {
            const boundBox = el.getBoundingClientRect();
            const coordX = boundBox.left;
            const coordY = boundBox.top;

            let toolTipPositionLeft = parseInt(coordX + (boundBox.width / 1.5));
            let toolTipPositionTop = parseInt(coordY + (boundBox.height / 1.5));

            if (parseInt(toolTipPositionLeft + tooltipBox.offsetWidth) <= window.innerWidth) {
                tooltipBox.style.left = toolTipPositionLeft + 'px';
            } else {
                tooltipBox.style.left = 'auto';
                tooltipBox.style.right = '5px';
            }

            if (parseInt(toolTipPositionTop + tooltipBox.offsetHeight) <= window.innerHeight) {
                tooltipBox.style.top = toolTipPositionTop + 'px';
            } else {
                tooltipBox.style.top = 'auto';
                tooltipBox.style.bottom = '5px';
            }

            tooltipBox.innerHTML = tooltipText;
            tooltipBox.classList.add('show');
        };
        el.onmouseout = function () {
            tooltipBox.classList.remove('show');
            tooltipBox.innerHTML = '';
        };
    });
}

/**
 * Product Teaser
 */
if (document.querySelector('.teaser-element--effect')) {
    window.addEventListener('scroll', function() {
        var windowHeight = window.innerHeight;
        var windowScrollTop = window.scrollY;
        var footer = document.querySelector('footer');
        var deactivatorHeight = footer ? footer.offsetHeight : 0;
        var deactivatorTop = footer ? footer.getBoundingClientRect().top + window.scrollY : 0;

        document.querySelectorAll('.teaser-element--effect').forEach(function(el) {
            var activatorEl;
            if (el.dataset.activator && el.dataset.activator != '') {
                activatorEl = document.querySelector(el.dataset.activator);
            }
            activatorEl = activatorEl || el;
            var activatorHeight = activatorEl.offsetHeight;
            var activatorTop = activatorEl.getBoundingClientRect().top + window.scrollY;

            if (activatorHeight < windowHeight) {
                activatorTop = activatorTop - (activatorHeight / 2);
            }

            var activateTrigger = activatorTop;
            var deactivateTrigger = activatorTop;

            if (activatorHeight < windowHeight) {
                activateTrigger = activateTrigger + activatorHeight - windowHeight;
                deactivateTrigger = deactivateTrigger + activatorHeight - windowHeight;
            }

            if (!el.classList.contains('dontDeactivate') && windowScrollTop > (deactivatorTop - deactivatorHeight)) {
                el.classList.remove('visible');
            } else if (el.classList.contains('visible') && (windowScrollTop + windowHeight) < deactivateTrigger) {
                el.classList.remove('visible');
            } else if (windowScrollTop <= 100) {
                el.classList.remove('visible');
            } else if ((windowScrollTop + activatorHeight) > activateTrigger) {
                el.classList.add('visible');
            }
        });
    });
}

/**
 * is Language == en
 */
function isLanguageEn() {
    let language = document.documentElement.getAttribute('lang');
    if (language == "en" || language.includes("en-"))
        return true;
    else
        return false;
}

/**
 * Countdown
 */
function countDown(countDownDate, id, removeAfterExpire, reloadAfterExpire, interval = null) {
    var now = parseInt(new Date().getTime());
    var countDownDate = parseInt(countDownDate);
    var distance = countDownDate - now;
    if (distance < 0) {
        if (interval !== null) {
            clearInterval(interval);
        }
        distance = 0;
        if (removeAfterExpire == 'true') {
            document.getElementById('cd-wrapper-' + id).remove();
        }
        if (reloadAfterExpire == 'true') {
            setTimeout(function () {
                window.location.reload();
            }, 1500);
        }
    }
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var daysLabel = document.getElementById('label-days-' + id);
    if (days == 1) {
        daysLabel.innerHTML = daysLabel.dataset.singular;
    } else {
        daysLabel.innerHTML = daysLabel.dataset.plural;
    }
    if (days < 10) {
        days = '0' + days;
    }
    document.getElementById('cd-days-' + id).innerHTML = days;

    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var hoursLabel = document.getElementById('label-hours-' + id);
    if (hours == 1) {
        hoursLabel.innerHTML = hoursLabel.dataset.singular;
    } else {
        hoursLabel.innerHTML = hoursLabel.dataset.plural;
    }
    if (hours < 10) {
        hours = '0' + hours;
    }
    document.getElementById('cd-hours-' + id).innerHTML = hours;

    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var minutesLabel = document.getElementById('label-minutes-' + id);
    if (minutes == 1) {
        minutesLabel.innerHTML = minutesLabel.dataset.singular;
    } else {
        minutesLabel.innerHTML = minutesLabel.dataset.plural;
    }
    if (minutes < 10) {
        minutes = '0' + minutes;
    }
    document.getElementById('cd-minutes-' + id).innerHTML = minutes;

    var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    var secondsLabel = document.getElementById('label-seconds-' + id);
    if (seconds == 1) {
        secondsLabel.innerHTML = secondsLabel.dataset.singular;
    } else {
        secondsLabel.innerHTML = secondsLabel.dataset.plural;
    }
    if (seconds < 10) {
        seconds = '0' + seconds;
    }
    document.getElementById('cd-seconds-' + id).innerHTML = seconds;
}

window.onload = function () {
    Array.prototype.forEach.call(document.getElementsByClassName('countdown-wrapper'), function (countdownWrapper) {
        var dateTime = stringToDate(countdownWrapper.dataset.datetime).getTime();
        var cdId = countdownWrapper.dataset.cdid;
        var removeAfterExpire = countdownWrapper.dataset.removeafterexpire;
        var reloadAfterExpire = countdownWrapper.dataset.reloadafterexpire;
        countDown(dateTime, cdId, removeAfterExpire, reloadAfterExpire);
        document.getElementById('cd-wrapper-' + cdId).style.opacity = '1';
        var interval = setInterval(function () {
            countDown(dateTime, cdId, removeAfterExpire, reloadAfterExpire, interval);
        }, 1000);
    });
};

/**
 * Create Hash out of String
 * @param {c} string 
 * @returns Hash
 */
function stringToHash(string) {
    var hash = 0;
    if (string.length == 0) {
        return hash;
    }
    for (i = 0; i < string.length; i++) {
        char = string.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash;
    }
    return hash;
}

/**
 * Parallax
 */
if (document.querySelector('.image--parallax')) {
    var lastScroll = window.pageYOffset;
    window.addEventListener('scroll', function () {
      var scrollPos = window.pageYOffset;
      var scrollDirection = (scrollPos > lastScroll) ? 'down' : 'up';
      lastScroll = scrollPos;
      checkParallax(scrollDirection, scrollPos);
    });
}

function checkParallax(scrollDirection, scrollPos) {
    var parallaxImages = document.querySelectorAll('.image--parallax');
    parallaxImages.forEach(function (element) {
      var elementPosTop = element.offsetTop;
      var elementPosMiddle = elementPosTop + (element.offsetHeight / 2);
      var elementPosMiddleInView = elementPosMiddle - window.innerHeight;
      if (scrollPos >= elementPosMiddleInView && scrollPos <= elementPosMiddle) {
        var minWidth = 100;
        var maxWidth = 110;
        var percentInView = (scrollPos - elementPosMiddleInView) / ((elementPosMiddle - elementPosMiddleInView) / 100);
        var newWidth = 100 + ((maxWidth - minWidth) / (100 / percentInView));
        var marginLeft = ((newWidth - minWidth) / 2) * -1;
        element.style.width = newWidth + '%';
        element.style.marginLeft = marginLeft + '%';
      }
    });
}

var isMobile = {
    Windows: function () {
        return /IEMobile/i.test(navigator.userAgent);
    },
    Android: function () {
        return /Android/i.test(navigator.userAgent);
    },
    BlackBerry: function () {
        return /BlackBerry/i.test(navigator.userAgent);
    },
    iOS: function () {
        return /iPhone|iPad|iPod/i.test(navigator.userAgent);
    },
    any: function () {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Windows());
    }
};

/**
 * String to Date
 */
function stringToDate(dateString) {
    var arr = dateString.split(/[- :]/);
    var year = arr[0];
    var months = arr[1] - 1;
    var days = arr[2];
    var hours = arr[3];
    var minutes = arr[4];
    if (arr[5]) {
        var seconds = arr[5];
    } else {
        var seconds = '00';
    }
    var date = new Date(year, months, days, hours, minutes, seconds);
    return date;
}

/**
 * Dumbotest
 */
function startDumboTest(testType) {
    var pageLink = '/pages/signature-thermal-bike-bib-tights';
    var productLink = '/products/signature-thermal-bike-bib-tights';
    var actLink = '/products/signature-thermal-bike-bib-tights/act';
    var currentHref = window.location.href;
    if (currentHref.includes(pageLink)) {
        var objectType = 'page';
    } else if (currentHref.includes(productLink)) {
        var objectType = 'product';
    }

    if (testType == 'original' && objectType == 'page') {
        var newHref = currentHref.replace(pageLink, productLink);
        window.location = newHref;
    } else if (testType == 'variant' && objectType == 'product' && currentHref.includes(actLink) == false) {
        var newHref = currentHref.replace(productLink, pageLink);
        window.location = newHref;
    } else if (testType == 'variant' && objectType == 'product' && currentHref.includes(actLink)) {
        dumboActRenderer();
        $('.loading-screen').removeClass('active');
    } else {
        $('.loading-screen').removeClass('active');
    }
}

/**
 * Discount Cookie set lifetime
 */
function modifyDiscountCookie() {
    let cookieName = 'discount_code';
    let checkCookieName = 'discountModified';
    let cookieHours = 24;
    let cookieValue = getCookie(cookieName);
    let checkCookieValue = getCookie(checkCookieName);
    if (cookieValue && checkCookieValue != true && checkCookieValue != 'true') {
        setCookie(cookieName, cookieValue, cookieHours);
        setCookie(checkCookieName, true, cookieHours);
    }
}

/**
 * 
 */
Array.prototype.forEach.call(document.getElementsByClassName('clear__button'), function(clearButton) {
    var inputId = clearButton.dataset.input;
    clearButton.addEventListener('click', (event) => {
        document.querySelector(inputId).value = '';
        if (inputId == '.template-search #Search-In-Template') {
            clearButton.style.opacity = 0;
        }
    });
});

function dynamicHoverImageLoader() {
    if (window.innerWidth >= 1150 || document.body.classList.contains('ryz-59')) {
        document.querySelectorAll('img.hover-image').forEach(img => {
            img.setAttribute('src', img.getAttribute('data-src'))
            img.setAttribute('srcset', img.getAttribute('data-srcset'))
            img.parentElement.classList.add("media--hover-effect")
        });
    } else {
        document.querySelectorAll('img.hover-image').forEach(img => {
            img.parentElement.classList.remove("media--hover-effect")
            img.removeAttribute('src')
            img.removeAttribute('srcset')
        });
    }
}

function addHighlyRatedBadge(destinationElement, ratingElement, location, lastAddedIndex = 0, index = 0) {
    const ratingElementTitle = ratingElement.getAttribute('title');
    const ratingCountElement = ratingElement.querySelector('.ruk-rating-snippet-count');
    if (ratingElementTitle && ratingCountElement) {
        const badgeCssClasses = ['highly-rated-badge', 'badge', 'badge--top-left', 'color-accent-2'];
        const badgeLabels = ['Top bewertet', 'Top rated']
        const reviewsRating = ratingElementTitle.replace(/ |Stars/g, '').split('-')[0];
        const reviewsCount = ratingCountElement.innerHTML.replace(/[\(\) ]|Reviews/g, '');
        if (reviewsRating > 4.5 && reviewsCount >= 15 && destinationElement && (location == 'pdp' || destinationElement.childElementCount === 0)) {
            lastAddedIndex = index;
            const highlyRatedBadge = document.createElement('span');
            highlyRatedBadge.classList.add(...badgeCssClasses);
            if (isLanguageEn()) {
                highlyRatedBadge.textContent = badgeLabels[1];
            } else {
                highlyRatedBadge.textContent = badgeLabels[0];
            }
            if (location == 'collection') {
                destinationElement.replaceChildren(highlyRatedBadge);
            } else if (location == 'pdp') {
                highlyRatedBadge.id = 'hrb-to-reviews';
                destinationElement.insertBefore(highlyRatedBadge, destinationElement.firstChild);
                highlyRatedBadge.addEventListener('click', function() {
                    if (document.querySelector('reviewsio-product-ratings')) {
                        document.querySelector('reviewsio-product-ratings').click();
                    }
                });
            }
        }
    }
    return lastAddedIndex;
}

/**
 * Updates the teaser cards on the page by appending filtered search parameters to their links.
 *
 * @param {string} searchParams - The search parameters to filter and append to the teaser card links.
 *
 * The function performs the following steps:
 * 1. Selects all elements with the class 'teaser-card'.
 * 2. Filters the provided search parameters to only include allowed parameters.
 * 3. Appends the filtered search parameters to the 'href' attribute of each teaser card link that includes '/collections/'.
 * 4. Adds the class 'changed-for-filtered' to each updated teaser card.
 */
function updateTeaserCards(searchParams) {
    const teaserCards = document.querySelectorAll('.teaser-card');
    if (teaserCards.length > 0) {
        const allowedParams = ['filter.v.m.filter.gender'];
        const urlParams = new URLSearchParams(searchParams);
        [...urlParams.keys()].forEach(key => {
            if (!allowedParams.includes(key)) {
                urlParams.delete(key);
            }
        });
        const filteredParams = urlParams.toString();
        teaserCards.forEach((element) => {
            let rawLink = element.dataset.rawlink;
            if (rawLink.includes('/collections/')) {
                let separator = rawLink.includes('?') ? '&' : '?';
                let newLink = rawLink + (filteredParams ? separator + filteredParams : '');
                element.setAttribute('href', newLink);
                element.classList.add('changed-for-filtered');
            }
        });
    }
}

/**
 * RYZ-63 / Sitewide - Add Animation for Search 
 * Types out a given text within a new DIV element placed inside .aa-InputWrapper.
 *
 * @param {string} text - The text to be typed out.
 * @param {Function} [callback] - An optional callback function to be executed after the text has been fully typed out.
 */

let typingInterval;
let typingStopped = false;
var typingInputWrapper = null;
var typingDiv = document.createElement('div');
typingDiv.classList.add('typing-div');
typingDiv.addEventListener('click', function() {
    stopTypingAnimation();
});

function typeTextInDiv(text, callback) {
    typingDiv.classList.remove('hide');
    let i = 0;
    typingDiv.textContent = "";
    function typeNextChar() {
        if (typingStopped) return;
        if (i < text.length) {
            typingDiv.textContent += text.charAt(i);
            i++;
            typingInterval = setTimeout(typeNextChar, 100);
        } else if (callback) {
            typingInterval = setTimeout(callback, 2000);
        }
    }
    typeNextChar();
}

function initTypingAnimation(numCalled = 0) {
    if (typingInputWrapper == null) {
        if (document.querySelector('.aa-InputWrapper')) {
            // Desktop
            typingInputWrapper = document.querySelector('.aa-InputWrapper');
        } else if (document.querySelector('.aa-DetachedSearchButton')) {
            // Mobile
            typingInputWrapper = document.querySelector('.aa-DetachedSearchButton');
        }
        if (typingInputWrapper == null && numCalled < 10) {
            setTimeout(function() {
                initTypingAnimation(numCalled + 1);
            }, 200);
            return;
        } else if (typingInputWrapper) {
            typingInputWrapper.appendChild(typingDiv);
        }
    }
    startTypingAnimation();

    if (document.querySelector('.aa-Input')) {
        document.querySelector('.aa-Input').addEventListener('input', function() {
            stopTypingAnimation();
        });
    }
}

function startTypingAnimation() {
    typingStopped = false;
    var searchSuggestions = [
        "Jersey", "Socken", "Bundles", "Bib Shorts", "Cap", "Vela", "Jacke", "Gutschein"
    ];
    if (isLanguageEn()) {
        searchSuggestions = [
            "Jersey", "Socks", "Bundles", "Bib shorts", "Cap", "Vela", "Jacket", "Gift card"
        ];
    }
    const randomText = searchSuggestions[Math.floor(Math.random() * searchSuggestions.length)];
    typeTextInDiv(randomText, startTypingAnimation);
}

function stopTypingAnimation(setFocus = true) {
    typingStopped = true;
    clearTimeout(typingInterval);
    typingDiv.classList.add('hide');
    typingDiv.textContent = "";
    if (setFocus) {
        setTimeout(function() {
            var searchInput = document.querySelector('.search-modal__content form .aa-Input');
            if (searchInput) {
                searchInput.focus();
                searchInput.click();
            }
        }, 200);
    }
}

// Zendesk Chatbot
function initZendeskChatbot(source) {
    if (typeof zE === 'undefined') {
        console.warn('Zendesk Chatbot script not loaded - mostly because of missing user consent. Please accept the consent to load the chatbot.');
        if (source !== 'retry') {
            setTimeout(function() {
                initZendeskChatbot('retry');
            }, 1000);
        }
    } else {
        if (isLanguageEn()) {
            zE("messenger:set", "locale", "en-US");
        } else {
            zE("messenger:set", "locale", "de");
        }
        window.zEMessenger = { autorender: false };
        zE("messenger", "render", {
            mode: "embedded",
            widget: {
                targetElement: "#zendesk-messenger-container"
            }
        });
        zE('messenger:on', 'close', function(event) {
            messengerContainer.classList.remove('active');
            document.body.classList.remove('zendesk-chatbot-open');
        });
        document.querySelector('#zendesk-messenger-container iframe')?.classList.add('zendesk-messenger-iframe');
    }
}

// Zendesk Chatbot
function openChatbot(target) {
    if (typeof zE !== 'undefined') {
        zE('messenger', 'open');
        messengerContainer.classList.add('active');
        document.body.classList.add('zendesk-chatbot-open');
    } else if (target !== 'consent') {
        document.querySelector('#fakeOpenChatbot .help-widget__content__element').click();
    }
}